import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-icon" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-emoji-icon',
},
  __name: 'emoji-icon',
  props: {
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }, null, -1)),
      _createElementVNode("circle", {
        cx: "15.5",
        cy: "9.5",
        r: "1.5",
        fill: __props.fill
      }, null, 8, _hoisted_3),
      _createElementVNode("circle", {
        cx: "8.5",
        cy: "9.5",
        r: "1.5",
        fill: __props.fill
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z",
        fill: __props.fill
      }, null, 8, _hoisted_5)
    ]))
  ]))
}
}

})